const toBoolean = value => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') return value === 'true';
  return Boolean(value);
};

const normalizeIceStunServerJson = value => {
  if (!value) return '';

  if (Array.isArray(value)) {
    return JSON.stringify(value);
  }

  if (typeof value === 'object') {
    return JSON.stringify([value]);
  }

  if (typeof value !== 'string') {
    return '';
  }

  try {
    const parsedValue = JSON.parse(value);

    if (Array.isArray(parsedValue)) {
      return JSON.stringify(parsedValue);
    }

    if (parsedValue && typeof parsedValue === 'object') {
      return JSON.stringify([parsedValue]);
    }

    return '';
  } catch {
    return '';
  }
};

export const normalizeBrowserPhoneBootstrap = payload => ({
  ...payload,
  enabled: toBoolean(payload?.enabled),
  load_alternate_lang: toBoolean(payload?.load_alternate_lang),
  wss_in_transport: toBoolean(payload?.wss_in_transport),
  ip_in_contact: toBoolean(payload?.ip_in_contact),
  web_socket_port: Number(payload?.web_socket_port || 0),
  transport_connection_timeout: Number(
    payload?.transport_connection_timeout || 0
  ),
  transport_reconnection_attempts: Number(
    payload?.transport_reconnection_attempts || 0
  ),
  transport_reconnection_timeout: Number(
    payload?.transport_reconnection_timeout || 0
  ),
  ice_stun_server_json: normalizeIceStunServerJson(
    payload?.ice_stun_server_json
  ),
});
